<template>
  <div id="default-logo" @click="toApplicationList">
    <img src="@/assets/logo.png" height="45" alt="Logo"/>
    <div id="default-logo-txt">Adapter</div>
  </div>
</template>

<script>
export default {
  name: "DefaultLogo",
  methods: {
    toApplicationList() {
      if (this.$route.path !== '/applications') {
        this.$router.push('/applications')
      }
    }
  }
}
</script>

<style scoped lang="scss">
#default-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  #default-logo-txt {
    color: white;
    display: flex;
    align-items: flex-end;
    height: 45px;
  }
}
</style>
